import React from 'react';
import { SubCategory, Topic } from 'types';
import { Box, constants, Loading } from '@match/react-component-library';
import { TopicView, SubCategoryView } from 'modules/components';

const { SPACE } = constants;

interface MainContentPageLayoutProps {
  currentSubCategories: SubCategory[];
  currentCategoryName?: string;
  currentTopic?: Topic;
  isLoading: boolean;
}

const MainContentPageLayout: React.FunctionComponent<MainContentPageLayoutProps> = ({
  currentSubCategories,
  currentCategoryName,
  currentTopic,
  isLoading,
}) => {
  return (
    <Box flex={3} display="flex">
      <Box
        display="flex"
        flexDirection="column"
        maxWidth={830}
        height="100%"
        paddingLeft={SPACE.XXXLARGE}
        width={!currentTopic ? '70%' : '100%'}
      >
        {isLoading && <Loading />}
        {!isLoading &&
        currentTopic &&
        currentCategoryName && ( // TODO set up zero state
            <TopicView
              answer={currentTopic.answer}
              categoryId={currentTopic.categoryId}
              id={currentTopic.id}
              title={currentTopic.title}
              categoryName={currentCategoryName}
            />
          )}
        {!isLoading && !(currentTopic && currentCategoryName) && (
          <SubCategoryView currentSubCategories={currentSubCategories} />
        )}
      </Box>
    </Box>
  );
};

export default MainContentPageLayout;
